import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import NoticeProductDetailWrap from '../../views/notice/product/detail/NoticeProductDetailWrap';
import { noticeProductActions } from '../../store/modules/notice/product';
import { appActions } from '../../store/modules/app';

class NoticeProductDetailContainer extends Component {
  getList = (data) => {
    const { pagination } = data;
    const { productNoticeId, getNoticeProductItemInfo } = this.props;

    getNoticeProductItemInfo({
      productNoticeId,
      pagination,
    });
  };

  render() {
    const { noticeProductDetail, getProductSubCategoryList, isEditable, form, setData } = this.props;

    return (
      <div>
        <NoticeProductDetailWrap
          noticeProductDetail={noticeProductDetail}
          getProductSubCategoryList={getProductSubCategoryList}
          isEditable={isEditable}
          form={form}
          setData={setData}
          getList={this.getList}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    noticeProductDetail: state.noticeProduct.noticeProductDetail,
  };
};

const mapDispatchToProps = {
  setData: noticeProductActions.setData,
  getNoticeProductItemInfo: noticeProductActions.getNoticeProductItemInfo,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(NoticeProductDetailContainer));
